<template>
  <!-- Trust Index Analytics Begins -->
  <div class="analytics-trust-index-tab" data-track="Trust Index Analytics Tab view">

    <!-- Bar Chart Begins -->
    <div class="columns">
      <div class="column card-column bar-chart">
        <div class="bar-chart-info-section">
          <span class="bar-chart-total-reviews">
            (Month on month)
          </span>
        </div>
        <div class="vue-bar-chart">
          <img class="spinner" src="/static/img/loaders/spinner.svg" v-if="isLoading">
          <vue-chart
            chart-type="ComboChart"
            :columns="trustIndexOverTimeColumns"
            :rows="trustIndexOverTimeRows"
            :options="mapOptions"
          ></vue-chart>
        </div>
      </div>
    </div>
    <!-- Bar Chart Ends -->


    <div class="columns">
      <!-- Your Trust Index Section start -->
      <div class="column is-4 box-width">
        <div class="trust-index-industry-ranking-box">

          <div class="header columns is-paddingless">
            <span class="column is-2"><img src="/static/img/reviews/industries.svg" alt="TrustIndex Score" class="img"/></span>
            <span class="column is-10">Your TrustIndex Score
              <span v-if="currentDateSelectionText != ''">(Based on {{currentDateSelectionText}})</span>
            </span>
          </div>

          <div class="columns score">
            <div class="column is-paddingless">
              <p>{{trustIndexSummary.trust_index}}</p>
            </div>
          </div>

          <div class="columns description">
            <div class="column is-paddingless">
              <p>What your score means</p>
              <p>&nbsp;</p>
              <p style="margin-bottom: 10px;">The Hellopeter TrustIndex is a way for consumers to determine how credible your business is</p>
              <p style="text-align: left;">
                <strong>Less than 3</strong> - Your online reputation is not good. Focus on implementing a review collection strategy to improve your TrustIndex<br/>

                <strong>Between 3 and 6</strong> - you’ve started to make an effort to build your online reputation<br/>

                <strong>Between 6 and 8</strong> - Your online reputation is good<br/>

                <strong>Above 8</strong> - Your online reputation is world class!</p>
              <p>&nbsp;</p>
              <p>Understand how your <a class="link" href="https://intercom.help/hellopeter/en/articles/3677903-your-trustindex" target="_blank">TrustIndex score</a> is calculated</p>
            </div>
          </div>

        </div>
      </div>
      <!-- Your Trust Index Section ends -->

      <!-- Your Trust Index Score Section start -->
      <div class="column is-1">
        <div class="columns trust-index-industry-ranking-up-down-box">
          <!-- Response Rate Breakdown Begins -->
          <div class="column">
            <div class="level response-rate-progress">
              <div class="column is-2 level-item response-time column is-3 level-item">
                <p>Your TrustIndex score has {{trustIndexSummary.trust_index_sensex[0] == '-' ? 'decreased' : 'increased'}}</p>
              </div>
            </div>
          </div>
          <!-- Response Rate Breakdown Ends -->

          <!-- Response Rate Begins -->
          <div class="column has-text-centered is-one-third">
            <span class="response-rate-percentage">

              <i v-if="trustIndexSummary.trust_index_sensex[0] == '-'" class="fas fa-long-arrow-alt-down has-text-danger up-down-icon"></i>
              <i v-else class="fas fa-long-arrow-alt-up has-text-success up-down-icon"></i>

              <strong>
                <animated-number
                  round="1"
                  :duration="500"
                  :formatValue="formatStats"
                  :value="Math.abs(trustIndexSummary.trust_index_sensex)"
                >
                </animated-number>%
              </strong>

            </span>
          </div> <!-- Response Rate Ends -->
        </div>
      </div>
      <!-- Your Trust Index Score Section ends -->
    </div>

  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc */
  import misc from '@/mixins/graphs.js'
  import AnimatedNumber from 'animated-number-vue'
  import axios from 'axios'

  export default {
    name: 'AnalyticsTrustIndex',
    metaInfo: {
      title: 'Business Portal | Hellopeter - Trust Index Analytics'
    },
    mixins: [misc],
    components: {
      AnimatedNumber
    },
    data () {
      return {
        isLoading: false,
        businessSlug: localStorage.getItem('org_slug'),
        trustIndexOverTimeRows: [],
        trustIndexOverTimeColumns: [],
        trustIndexSummary: {
          trust_index_sensex: 0
        },
        currentDateSelectionText: ''
      }
    },
    computed: {
      /**
       * Creating a payload for showing graph
       * @return {object}
       */
      mapOptions () {
        return Object.assign(this.reviewAnalyticsOptions, {
          height: 386,
          isStacked: true,  // Multiple columns in single point
          animation: {easing: 'out', startup: true, duration: 800},
          chartArea: {top: '2%', left: '4%', width: '94.5%', height: '80%', bottom: '5%'},
          series: {
            0: {type: 'line', color: '#397EF5'}
          },
          pointSize: 20
        })
      }
    },
    created () {
      this.$parent.$on('onDateChangeForTrustIndexTab', data => {
        this.fetchTrustIndexAnalytics(data)
        this.currentDateSelectionText = data.text
      })

      this.$parent.$emit('getSelectedDates', 'AnalyticsTrustIndex')
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Industry Ranking Analytics'
      })
    },
    beforeDestroy () {
      this.$parent.$off('onDateChangeForTrustIndexTab')
    },
    methods: {
      /**
       * Format the float numbers upto two digits after decimal
       * @param {string} value Value of stat
       * @return {string|integer}
       */
      formatStats (value) {
        return !Number.isInteger(value) ? `${Number(value).toFixed(2)}` : value
      },
      /**
       * Fetch Trust Index analytics data on date change
       *
       * @param {object} event The Change event that was fired
       * @returns {void}
       */
      fetchTrustIndexAnalytics (event) {
        axios.get(`/analytics/${this.businessSlug}/trust-index-analytics/?startDate=${event.startDate}&endDate=${event.endDate}`)
          .then(({data}) => {
            this.trustIndexOverTimeRows = data.data.trustIndexData.rows
            this.trustIndexOverTimeColumns = data.data.trustIndexData.columns
            this.trustIndexSummary = data.data.summary
          })
          .catch((error) => {
            console.log('error', error)
          })
      }
    }
  }
</script>

<!-- Global CSS Begins -->
<style scoped>
  .level .level-right a {
    width: 130px;
    height: 37px;
    border-radius: 2px;
    border: solid 1px #58595b;
  }
  .bar-chart {
    width: 81%;
    padding: 0;
    margin-right: 1%;
    position: relative;
  }
  .columns .bar-chart {
    height: 451px;
  }
  .bar-chart-info-section {
    line-height: 2em;
    margin: 13px 13px 0 17px;
  }
  .bar-chart-total-reviews {
    color: #58595b;
    font-size: 11px;
    margin-right: 10px;
  }
  .vue-bar-chart {
    margin-top: 1%;
  }
  .vue-bar-chart .spinner {
    top: 40%;
    left: 47%;
    width: 9%;
    z-index: 1;
    position: absolute;
  }

  .trust-index-industry-ranking-up-down-box {
    width: 416px;
    height: 101px;
    border: solid 1px rgba(88, 89, 91, 0.32);
  }

  .trust-index-industry-ranking-up-down-box .response-time   {
    border-right: solid 1px rgba(88, 89, 91, 0.32);
  }

  .trust-index-industry-ranking-up-down-box .response-rate-percentage {
    line-height: 85px;
  }

  .trust-index-industry-ranking-up-down-box .response-rate-percentage strong {
    font-size: 24px;
    font-weight: bolder;
    line-height: 24px;
    display:inline-block;
  }

  .trust-index-industry-ranking-up-down-box .up-down-icon {
    font-size: 40px;
    margin-right: 10px;
    vertical-align: middle;
    margin-bottom: 18px;
  }

  .box-width {
    width: 520px;
  }

  .trust-index-industry-ranking-box {
    border: solid 1px rgba(88, 89, 91, 0.32);
    padding: 15px;
  }

  .trust-index-industry-ranking-box .header {
    padding: 15px 0;
    border-bottom: solid 1px rgba(88, 89, 91, 0.32);
  }
  .trust-index-industry-ranking-box .header .is-2 {
    text-align: center;
  }
  .trust-index-industry-ranking-box .header .img {
    width: 15.5px;
    height: 30px;
  }

  .trust-index-industry-ranking-box .score {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }

  .trust-index-industry-ranking-box .description {
    text-align: center;
    font-size: 12px;
    margin-bottom: 10px;
  }

  /* Media Queries begins */
  /* Media Query For Tablet */
  @media screen and (min-width: 767px) {
    .bar-chart {
      margin-right: 0;
    }
  }

  /* Media Query For Desktop and Big Screens */
  @media screen and (min-width: 1280px) {
    .bar-chart {
      margin-right: 1%;
    }
  }
  @media (max-width:1200px) and (min-width:768px){
  }
  @media (max-width:991px) and (min-width:768px){
  }
  /* Media Queries ends */
</style>
<!-- Local CSS Ends -->



// WEBPACK FOOTER //
// src/pages/analytics/trust-index-and-industry-ranking/AnalyticsTrustIndex.vue